import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { SupportTicket } from 'src/app/interfaces/chat';
import { SupportAdminService } from 'src/app/services/support/support-admin.service';
import { SupportTicketService } from 'src/app/services/support/support-ticket.service';

@Component({
  selector: 'app-ticket-detail-page',
  templateUrl: './ticket-detail.page.html',
  styleUrls: ['./ticket-detail.page.scss'],
})
export class TicketDetailPage implements OnInit, OnDestroy {

  ticketId: string;

  supportTicket: SupportTicket;

  ready: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private supportAdminService: SupportAdminService,
    private supportTicketService: SupportTicketService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
      
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      this.ready = false;
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;
      if (param?.ticketId) {
        this.ticketId = param.ticketId;
      } else if (state?.ticketId) {
        this.ticketId = state.ticketId;
      } else {
        this.ticketId = '';
      }

      if (param?.supportTicket) {
        this.supportTicket = param.supportTicket;
      } else if (state?.supportTicket) {
        this.supportTicket = state.supportTicket;
      } else {
        this.supportTicket = null;
      }

      if (this.supportTicket?.ticketId) {
        this.ready = true;
      } else if (this.ticketId) {
        this.getSupportTicket();
      } else {
        this.ready = true;
      }
    });
  }

  ionViewWillEnter() {
  }

  ionViewWillLeave() {
  }

  getSupportTicket() {
    if (this.ticketId) {
      if (this.supportAdminService.checkAdmin()) {
        this.supportTicket = this.supportAdminService.getSupportTicketById(this.ticketId);
        if (!this.supportTicket?.ticketId) {
          setTimeout(() => {
            this.getSupportTicket();
          }, 1000);
        } else {
          this.ready = true;
        }
      } else {
        this.supportTicket = this.supportTicketService.getSupportTicketById(this.ticketId);
        if (!this.supportTicket?.ticketId) {
          setTimeout(() => {
            this.getSupportTicket();
          }, 1000);
        } else {
          this.ready = true;
        }
      }
    }
  }

  setTicketId(ticketId: string) {
    if (ticketId) {
      this.ticketId = ticketId;
    }
  }

  setSupportTicket(supportTicket: SupportTicket) {
    if (supportTicket?.ticketId) {
      this.supportTicket = supportTicket;
    }
  }

}
